import React from 'react'
import { useHistory } from 'react-router'
import { Button } from '../../../design_system/components/Button/Button.jsx'
import NoNewsBanner from './assets/NoNewsBanner.png'

export const NoNewsLanding = () => {
    const history = useHistory()
    return (
        <div className="text-center no-news-landing-layout">
            <img src={NoNewsBanner} className="no-news-landing-banner" />
            <div className="headline-l-bold no-news-landing-title">We're sorry! News hasn't been found with the given data</div>
            <div className="body-m-semibold no-news-landing-subtitle">Please ensure you've added enough prospects to get news results.</div>
            <div className="flex justify-center no-news-landing-button">
                <Button Size="Medium" onClick={() => { history.push('/import_prospects') }}>Upload more prospects</Button>
            </div>
        </div>
    )
}
